import React, { Component } from 'react'
import { TextField, TextArea } from './eventFormComponents'
import * as styled from '../../styles/style'
import { GuestItemContainer } from '../../containers'
import { capacityToHuman } from '../../helpers/enums'
import { validator, errorMessages } from '../../helpers/validation'
import authHeader from '../../helpers/authHeader'
import WebMailHelper from '../host/WebMailHelper'
import { ButtonLink, ButtonLinkExternal } from '../generic'
import styledComponents from 'styled-components';
import * as variables from '../../styles/variables';

const GuestListActionsContainer = styledComponents.div`
  background-color: ${variables.colours.lightGrey};
  margin-bottom: 16px;
  padding: 16px 16px 0px 16px;
`

class GuestList extends Component {
  constructor(props) {
    super(props)
    this.state = {
      newGuest: {
        first_name: '',
        last_name: '',
        email: '',
      },
      error: '',
      group_message: '',
      show_group_message: false,
      warning: [],
    }
  }

  handleNewGuestChange = (event) => {
    let name, warning_name
    name = warning_name = event.target.name
    let guest = this.state.newGuest
    guest[name] = event.target.value

    this.setState({
      newGuest: guest
    })
  }

  validateGuest = (guest) => {
    if (guest.first_name === '' || guest.last_name === '' || guest.email === '') {
      this.setState({
        errorMessage: 'All fields are mandatory.'
      })
      return false
    }
    else if (!validator.isEmail(guest.email)) {
      this.setState({
        errorMessage: 'Please enter a valid email address.'
      })
      return false
    } else {
      this.setState({
        errorMessage: ''
      })
      return true
    }
  }

  handleSendInvitation = () => {
    let guest = this.state.newGuest
    guest.status = 1

    if (this.validateGuest(guest)) {
      this.props.addGuest(guest, (success) => {
        if (success) {
          guest.first_name = ''
          guest.last_name = ''
          guest.email = ''
          this.setState({
            newGuest: guest
          })
        }
      })
    }
  }

  handleAddGuest = () => {
    let guest = this.state.newGuest
    guest.status = 'yes'

    if (this.validateGuest(guest)) {
      this.props.addGuest(guest, (success) => {
        if (success) {
          guest.first_name = ''
          guest.last_name = ''
          guest.email = ''
          this.setState({
            newGuest: guest
          })
        }
      });
    }
  }

  onKeyPress(event) {
    if (event.which === 13 /* Enter */) {
      event.preventDefault();
    }
  }

  onGroupMessageChange = (event) => {
    this.setState({
      group_message: event.target.value
    })
  }

  onGroupMessageSubmit = () => {
    // POST /events/2/message_guests
    //   body: { message: "" }
    if (this.state.group_message === '') {
      let warning = this.state.warning;
      warning['group_message'] = 'Please enter a message to your guests';
      this.setState({
        warning: warning
      });

      return; // oh no you didn't
    }

    console.log("send this: ", this.state.group_message);

    const requestOptions = {
      headers: authHeader(),
      method: 'POST',
      body: JSON.stringify({message: this.state.group_message}),
    };

    let event_id = this.props.event.id;
    let url = '/api/events/' + event_id + '/message_guests';

    fetch(url, requestOptions)
      .then(
        response => {
          if (response.ok) {
            this.props.successAlert("Message sent successfully!");
          } else {
            throw Error(response.statusText);
          }
        })
      .catch((error) => {
        this.props.errorAlert("There was a problem sending the message. Please contact host@onthetablebc.com <br>" + error);
        console.log(error);
      });

    // clear the textarea and close
    this.setState({
      group_message: '',
      show_group_message: false,
    })
  }

  toggleGroupMessage = () => {
    this.setState({
      show_group_message: !this.state.show_group_message
    })
  }

  render() {
    const { guests, event } = this.props;
    const { first_name, last_name, email } = this.state.newGuest;
    // let yes = 0, no = 0;
    let noAttendingGuests = [];
    let attendingGuests = [];
    if (guests && guests.length > 0) {
      noAttendingGuests = guests.filter((guest) => {return guest.status === 'no';});
      attendingGuests = guests.filter((guest) => {return guest.status === 'yes';});
    }

    // compare guests
    function compareGuests(a, b) {
      if (a.status < b.status) {
        return -1;
      }
      if (a.status > b.status) {
        return 1;
      }
      if (a.first_name < b.first_name) {
        return -1;
      }
      if (a.first_name > b.first_name) {
        return 1;
      }
      if (a.last_name < b.last_name) {
        return -1;
      }
      if (a.last_name > b.last_name) {
        return 1;
      }
      // a must be equal to b
      return 0;
    }

    attendingGuests.sort(compareGuests);

    // for (let guest of guests) {
    //   if (guest.status === 'yes') { yes++ }
    //   if (guest.status === 'no') { no++ }
    // }

    return (
      <div>
        <div style={{marginBottom: '20px'}}>
          <ButtonLink secondary small to="/host/hub/forms/how-to-invite" style={{marginRight: '16px', marginBottom: '8px'}}>{"Add More Guests >"}</ButtonLink>
          <ButtonLinkExternal secondary small onClick={this.toggleGroupMessage}>Email All Attendees</ButtonLinkExternal>
        </div>
        {this.state.show_group_message && (
          <GuestListActionsContainer>
            <styled.FormRow style={{marginBottom: '20px'}}>
              <h2>Email All Attendees</h2>
              <styled.FullWidthFieldGroup>
                <WebMailHelper event={event} guests={attendingGuests} subject=" " />
              </styled.FullWidthFieldGroup>
            </styled.FormRow>
          </GuestListActionsContainer>
        )}

        <div className="invited-guests">
          <h2 style={{marginBottom: '5px'}}>Attending</h2>
          <styled.GuestList>
            {attendingGuests.map((guest) => {
              return (
                <GuestItemContainer key={guest.id} guest={guest} updateGuest={this.props.updateGuest} />
                );
            })}
            { attendingGuests.length === 0 ? (<p>No guests replied "Yes" yet.</p>) : '' }
          </styled.GuestList>
        </div>
        
        <div className="waitlist">
          <h2 style={{marginBottom: '5px'}}>Not Attending</h2>
          <styled.GuestList>
            {noAttendingGuests.map((guest) => {
              return (
                <GuestItemContainer key={guest.id} guest={guest} updateGuest={this.props.updateGuest} />
                );
            })}
            { noAttendingGuests.length === 0 ? (<p>No guests replied "No" yet.</p>) : '' }
          </styled.GuestList>
        </div>
      </div>
    )
  }
}

export default GuestList;
